// extracted by mini-css-extract-plugin
export default {"followAthleteCTA":"FollowAthleteCTA--followAthleteCTA--NJc-V","followAthleteCta":"FollowAthleteCTA--followAthleteCTA--NJc-V"};